/* eslint-disable import/extensions */
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */

// Import all translation files
import en from './translations/en.json';
import fr from './translations/fr.json';
import ge from './translations/ge.json';
import hi from './translations/hi.json';
import mal from './translations/mal.json';
import es from './translations/es.json';
import ka from './translations/ka.json';
import ta from './translations/ta.json';
import ma from './translations/ma.json';
import or from './translations/or.json';
import ba from './translations/ba.json';
import ar from './translations/ar.json';

// Create a map of translations
const translationsMap = {
	en, fr, ge, hi, mal, es, ka, ta, ma, or, ba, ar
};

const list = [
	{
		name   : 'English',
		file   : 'en',
		locale : [ 'en', 'en-en' ]
	},
	{
		name   : 'français',
		file   : 'fr',
		locale : [ 'fr', 'fr-fr' ]
	},
	{
		name   : 'German',
		file   : 'ge',
		locale : [ 'ge', 'ge-ge' ]
	},
	{
		name   : 'हिन्दी',
		file   : 'hi',
		locale : [ 'hi', 'hi-hi' ]
	},
	{
		name   : 'മലയാളം',
		file   : 'mal',
		locale : [ 'mal', 'mal-mal' ]
	},
	{
		name   : 'Española',
		file   : 'es',
		locale : [ 'es', 'es-es' ]
	},
	{
		name   : 'ಕನ್ನಡ',
		file   : 'ka',
		locale : [ 'ka', 'ka-ka' ]
	},
	{
		name   : 'தமிழ்',
		file   : 'ta',
		locale : [ 'ta', 'ta-ta' ]
	},
	{
		name   : 'मराठी',
		file   : 'ma',
		locale : [ 'ma', 'ma-ma' ]
	},
	{
		name   : 'ଓରିୟା',
		file   : 'or',
		locale : [ 'or', 'or-or' ]
	},
	{
		name   : 'বাংলা',
		file   : 'ba',
		locale : [ 'ba', 'ba-ba' ]
	},
	{
		name   : 'عربي',
		file   : 'ar',
		locale : [ 'ar', 'ar-ar' ]
	}
];

export const detect = () =>
{
	const localeFull = (navigator.language ||
		(navigator as any).browserLanguage).toLowerCase();

	// const localeCountry = localeFull.split(/[-_]/)[0];

	// const localeRegion = localeFull.split(/[-_]/)[1] || null;

	return localeFull;
};

export const getList = () => list;

export interface ILocale {
	name: string;
	file: string;
	locale: string[];
	messages: any;
}

export const loadOne = (locale: string): ILocale =>
{
	let res: any = {};

	try
	{
		res = list.filter(
			// (item) => item.locale.includes(locale) || item.locale.includes(locale.split(/[-_]/)[0])
			(item) => item.locale.includes(locale)
		)[0];

		// Use the translation map instead of require
		res.messages = translationsMap[res.file as keyof typeof translationsMap];
	}
	catch
	{
		res = list.filter((item) => item.locale.includes('en'))[0];

		// Use the translation map instead of require
		res.messages = translationsMap[res.file as keyof typeof translationsMap];
	}

	return res;
};
